import { Quill } from "@vueup/vue-quill";
const Parchment = Quill.import("parchment");

export const useRegisterAttributors = () => {
  const registerDataAttributor = (
    attrKey: string,
    dataName: string = attrKey,
    scope: any = Parchment.Scope.INLINE
  ) => {
    const Attrib = new Parchment.Attributor.Attribute(attrKey, dataName, {
      scope,
    });
    Quill.register(Attrib, true);
    return Attrib;
  };

  const registerInlineData = (attrKey: string) => {
    return registerDataAttributor(attrKey, attrKey, Parchment.Scope.INLINE);
  };

  const registerBlockData = (attrKey: string) => {
    return registerDataAttributor(attrKey, attrKey, Parchment.Scope.BLOCK);
  };

  return {
    registerDataAttributor,
    registerInlineData,
    registerBlockData,
  };
};
